import { languages } from "../../assets/locales/languages";

export function isValidLanguageKey(key: string): boolean {
  return key in languages;
}
